module.exports = __webpack_public_path__ + "img/icon-ny-3.f09bcdf5.svg";